import CartQuantity from "./components/cart-quantity"

export default class Header {
    constructor(element) {
        this.header = element
        this.navbar = this.header.querySelector('.navbar')
        this.mobile = this.header.querySelector('.navbar-mobile')
        this.cartQuantity = this.header.querySelector('.shopping-cart-count')

        // Init nav cart
        window.visitHoogstratenCart = new CartQuantity(this.cartQuantity)

        // Init mobile switcher
        this.mobile.addEventListener('click', () => this.toggleMobileMenu())
    }

    toggleMobileMenu() {
        document.querySelector('body').classList.toggle('noscroll')
        this.navbar.classList.toggle('open')
    }
}